export { default, type ReadOnlyInputProps } from './ReadOnlyInput';
